<script setup lang="ts">
import { useRoute } from 'vue-router'

import { FlexComponent, TypographyComponent, BoxComponent } from '@/ui-library'

import LogoIcon from '@/assets/icons/metapic-logo-white.svg?component'

const route = useRoute()
</script>

<template>
  <flex-component justify="space-between" align="center" class="header">
    <flex-component :gap="40" align="center">
      <box-component :pt="17" :pr="8" :pl="8">
        <router-link to="/">
          <el-icon :size="48">
            <logo-icon />
          </el-icon>
        </router-link>
      </box-component>

      <typography-component variant="headline-medium" color="#fff" class="title">
        {{ route.meta?.title }}
      </typography-component>
    </flex-component>
    <slot name="action-buttons" />
  </flex-component>
</template>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 72px;
  padding-left: 8px;
  padding-right: 24px;
  z-index: 998;

  background: #222;
  color: #fff;
}

.title {
  margin: 0;
  padding: 0;
  border-bottom: none;
}
</style>
